import { Injectable } from '@angular/core'
import { MatPaginatorIntl } from '@angular/material/paginator'
import { TranslateService } from '@ngx-translate/core'
import { LanguageService } from 'src/app/core/services/languages/language.service'

@Injectable()
export class CustomMatPaginatorIntl extends MatPaginatorIntl {
  private currentLocale = 'en-US'
  private formatter = new Intl.NumberFormat(this.currentLocale)

  constructor(private translate: TranslateService, private langService: LanguageService) {
    super()

    // Listen to app language changes
    this.langService.getSelectedLanguage().subscribe(lang => {
      this.currentLocale = lang?.bcp47Code === 'ar-SA' ? 'ar-SA' : 'en-US'
      this.formatter = new Intl.NumberFormat(this.currentLocale)
      this.loadLabels()
    })

    // When user changes language
    this.translate.onLangChange.subscribe(() => this.loadLabels())
    this.translate.onTranslationChange.subscribe(() => this.loadLabels())

    // Initial load
    this.loadLabels()
  }

  private loadLabels(): void {
    const keys = [
      'PAGINATION.first',
      'PAGINATION.itemsPerPage',
      'PAGINATION.last',
      'COMMON.next',
      'COMMON.previous',
      'COMMON.of'
    ]

    // IMPORTANT — waits for translations to actually exist
    this.translate.get(keys).subscribe(translations => {
      this.firstPageLabel = translations['PAGINATION.first']
      this.itemsPerPageLabel = translations['PAGINATION.itemsPerPage']
      this.lastPageLabel = translations['PAGINATION.last']
      this.nextPageLabel = translations['COMMON.next']
      this.previousPageLabel = translations['COMMON.previous']

      this.changes.next()
    })
  }

  override getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) {
      return `${this.format(0)} / ${this.format(length)}`
    }

    const startIndex = page * pageSize
    const endIndex = Math.min(startIndex + pageSize, length)
    const of = this.translate.instant('COMMON.of') || 'of'

    return `${this.format(startIndex)} – ${this.format(endIndex)} ${of} ${this.format(length)}`
  }

  private format(value: number): string {
    return this.formatter.format(value)
  }
}
